export default __webpack_public_path__ + "static/media/infoGray.762b86ab.svg";